import { alpha } from "@mui/material/styles";
import theme from "src/theme";
import type { TranscriptLineView } from "./transcriptSync";

// Translucent so the page shows through the tint instead of dimming the text.
const TINT_OPACITY = 0.4;

const SPEAKER_TINTS = [
  ...theme.palette.categorical.cool,
  ...theme.palette.categorical.warm,
].map((color) => alpha(color, TINT_OPACITY));

/**
 * A tint per handset, assigned in the order handsets first speak.
 *
 * Ordering by first appearance keeps the handsets in one exchange distinct, which
 * hashing the id would not. There are far more handsets than tints, so a tint
 * separates neighbouring speakers rather than identifying one.
 */
export const buildSpeakerTints = (
  lines: readonly TranscriptLineView[]
): ReadonlyMap<number, string> => {
  const tints = new Map<number, string>();
  for (const line of lines)
    for (const word of line.words) {
      if (word.sourceId == null || tints.has(word.sourceId)) continue;
      const tint = SPEAKER_TINTS[tints.size % SPEAKER_TINTS.length];
      if (tint) tints.set(word.sourceId, tint);
    }
  return tints;
};
